import { useQuery } from '@apollo/client/react';
import { PageTitle } from '@optools/components/layout/typography';
import { FilteredSearch } from '@optools/components/search/filtered-search';
import { Separator } from '@optools/components/ui/separator';
import { GET_PIPELINE_CONFIGS } from '@optools/services/operator-gateway/pipeline-config/queries';
import { PipelineConfigInfo } from '@optools/services/operator-gateway/types/generated/graphql';
import { useTeamsQuery } from '@optools/store/statsApiSlice';
import { PipelineConfigSheet } from '@optools/tools/btc-tools/components/pipeline-config-sheet';
import {
  TeamConfigCard,
  TeamConfigGrid,
} from '@optools/tools/btc-tools/components/team-config-card';
import { filterTeamsBySearchTerm } from '@optools/utils/filter';
import { hydrateWithTeams } from '@optools/utils/teams';
import { createFileRoute } from '@tanstack/react-router';
import { Database } from 'lucide-react';
import { useState } from 'react';

export const Route = createFileRoute('/_auth/btc-tools/configs/pipeline')({
  component: RouteComponent,
});

export function RouteComponent() {
  const { data: teams = [] } = useTeamsQuery();
  const { data } = useQuery(GET_PIPELINE_CONFIGS);
  const [currentConfig, setCurrentConfig] = useState<PipelineConfigInfo | null>(null);

  const hydratedConfigs = hydrateWithTeams(data?.pipelineConfigs ?? [], teams);

  return (
    <div className="space-y-4">
      <PageTitle>Pipeline Configs</PageTitle>
      <FilteredSearch
        data={hydratedConfigs}
        filterFn={(configs, term) =>
          filterTeamsBySearchTerm(configs, term, (config) => [config.id])
        }
        placeholder="Search teams or config ID">
        {(filteredConfigs) => (
          <TeamConfigGrid>
            {filteredConfigs.map((pipelineConfigInfo) => {
              return (
                <button
                  key={pipelineConfigInfo.id}
                  className="group text-left"
                  onClick={() => setCurrentConfig(pipelineConfigInfo)}>
                  <TeamConfigCard
                    className="h-full transition-colors group-hover:bg-muted"
                    team={pipelineConfigInfo.team}
                    teamId={pipelineConfigInfo.teamId}>
                    <Separator className="my-4" />
                    <div className="flex flex-wrap justify-between gap-4">
                      <h2 className="flex items-center gap-1 text-sm">
                        <Database className="size-4" />
                        Config ID
                      </h2>
                      <p className="text-sm">{pipelineConfigInfo.id}</p>
                    </div>
                  </TeamConfigCard>
                </button>
              );
            })}
          </TeamConfigGrid>
        )}
      </FilteredSearch>

      <PipelineConfigSheet
        config={currentConfig}
        open={!!currentConfig}
        onOpenChange={() => setCurrentConfig(null)}
      />
    </div>
  );
}
